import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormLabel,
  Divider,Input,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { DynamicFormActions } from "../../redux/actions/DynamicFormAction";
import { history } from "../helpers/History";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import EsignatureConfirmation from './EsignatureConfirmation'
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class DynamicForm extends React.Component {
  constructor(props) {
    super(props);
    const formid = this.props.formid;
    this.state = {
      isDynamicFormUpdated: false,
      formName: "",
      displayName: "",
      formDescriptioin: "",
      isEsignatureRequired: false,
      formid: formid,
      status: "",
      patinetId: "",
      signatureName:'',
      formText: [],
      eSignatureDone:false,
      firstName : '',
      lastName : '',
      disableSubmit:this.props.disableSubmit
    };
  }

  componentDidMount() {
    if (this.state.formid && this.state.formid.length > 0) {
      this.props.findById(this.state.formid);
    }
  }
  componentWillUnmount() {
    this.props.clear();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.dynamicFormDetails &&
      this.props.dynamicFormDetails.id &&
      this.state.id != this.props.dynamicFormDetails.id
    ) {
      this.setState({
        id: this.props.dynamicFormDetails.id,
        formName: this.props.dynamicFormDetails.formName,
        displayName: this.props.dynamicFormDetails.displayName,
        formDescriptioin: this.props.dynamicFormDetails.formDescriptioin,
        isEsignatureRequired:
        this.props.dynamicFormDetails.isEsignatureRequired && this.props.dynamicFormDetails.isEsignatureRequired ==="true"?true:false,
        status: this.props.dynamicFormDetails.status,
        formText: this.props.dynamicFormDetails.formText,
      });
    }
    if (this.state.isDynamicFormUpdated != this.props.isDynamicFormUpdated) {
      this.setState({ isDynamicFormUpdated: this.props.isDynamicFormUpdated });
      if (this.props.isDynamicFormUpdated) {
        history.goBack();
      }
    }
  }
  handleFormChange = (index, value) => {
    let form = [...this.state.formText];
    form[index].value = value;
    this.setState({ formText: form });
  };

  handleSubmit = (payload) => {
    this.setState({ disableSubmit: true });
      let data = {
        "firstName": payload.firstName,
        "lastName": payload.lastName,
        "fieldValues": this.state.formText,
        "esignatureCaptured": "true",
      }
    this.props.handleSubmit(data);
  }
  handleSubmitWithOutSignature = () => {
    this.setState({ disableSubmit: true });
    let data = {
      "firstName": '',
      "lastName": '',
      "fieldValues": this.state.formText,
      "esignatureCaptured": "false",
    }
    this.props.handleSubmit(data);
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Document Upload</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
          <CssBaseline />
          <Paper className={classes.paper}>
              <form
                  className={classes.form}
                  noValidate
                  name="form"
                >
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      color="primary"
                      align="center"
                      variant="h3"
                      className={classes.typography}
                    >
                      {this.state.displayName}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      color="default"
                      variant="h5"
                      className={classes.typography}
                    >
                      {this.state.formDescriptioin}
                    </Typography>
                  </Box>
                  <Grid container spacing={1}>
                    {this.state.formText &&
                      this.state.formText.length > 0 &&
                      this.state.formText.map((value, index) => {
                        return (
                          <Grid item xs={12} md={12} key={index}>
                            {value && value.type == "Date" && (
                              <TextField
                                fullWidth
                                margin="normal"
                                id={value.label}
                                name={value.label}
                                label={value.label}
                                type="date"
                                className={classes.textField}
                                onChange={(e) => {
                                  this.handleFormChange(index, e.target.value);
                                }}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                            {value && value.type == "DateTime" && (
                              <TextField
                                fullWidth
                                margin="normal"
                                id={value.label}
                                name={value.label}
                                label={value.label}
                                type="datetime-local"
                                className={classes.textField}
                                onChange={(e) => {
                                  this.handleFormChange(index, e.target.value);
                                }}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                            {value && value.type == "Text" && (
                              <TextField
                                fullWidth
                                label={value.label}
                                margin="normal"
                                variant="outlined"
                                autoComplete="off"
                                onChange={(e) => {
                                  this.handleFormChange(index, e.target.value);
                                }}
                              />
                            )}
                            {value && value.type == "CheckBox" && (
                              <FormControlLabel
                                margin="normal"
                                control={
                                  <Checkbox
                                    name={value.label}
                                    onChange={(e, checked) => {
                                      this.handleFormChange(index, checked);
                                    }}
                                  />
                                }
                                label={value.label}
                              />
                            )}
                            {value && value.type == "Select" && (
                              <FormControl
                                margin="normal"
                                variant="outlined"
                                className={classes.formControl}
                                fullWidth
                              >
                                <InputLabel htmlFor={value.label}>
                                  {value.label}
                                </InputLabel>
                                <Select
                                  native
                                  label={value.label}
                                  onChange={(e) => {
                                    this.handleFormChange(
                                      index,
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option aria-label="None" value="" />
                                  {value &&
                                    value.options &&
                                    value.options.length > 0 &&
                                    value.options.split("~").map((element) => {
                                      return (
                                        <option value={element}>
                                          {element}
                                        </option>
                                      );
                                    })}
                                </Select>
                              </FormControl>
                            )}

                            {value && value.type == "MultiSelect" && (
                               <FormControl
                               margin="normal"
                               component="fieldset"
                               className={classes.resetOptions}
                               fullWidth
                             >
                              <Autocomplete
                                multiple
                                id="checkboxes-tags-demo"
                                options={
                                  value &&
                                  value.options &&
                                  value.options.length > 0
                                    ? value.options.split("~")
                                    : []
                                }
                                disableCloseOnSelect
                                getOptionSelected={(option, value) =>
                                  option === value
                                }
                                getOptionLabel={(option) => {
                                  return option;
                                }}
                                onChange={(event, newValue) => {
                                  this.handleFormChange(
                                    index,
                                    newValue.join("~")
                                  );
                                }}
                                renderOption={(option, { selected }) => (
                                  <React.Fragment>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option}
                                  </React.Fragment>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    label={value.label}
                                    placeholder={value.label}
                                  />
                                )}
                              />
                              </FormControl>
                            )}
                            {value && value.type == "Radio" && (
                              <FormControl
                                margin="normal"
                                component="fieldset"
                                className={classes.resetOptions}
                                fullWidth
                              >
                                <FormLabel component="legend">
                                  {value.label}
                                </FormLabel>

                                <RadioGroup
                                  row
                                  aria-label={value.name}
                                  name={value.name}
                                  defaultValue="top"
                                  onChange={(e) => {
                                    let value = e.target.value;
                                  }}
                                >
                                  {value &&
                                    value.options &&
                                    value.options.length > 0 &&
                                    value.options
                                      .split("~")
                                      .map((value) => (
                                        <FormControlLabel
                                          value={value}
                                          label="Start"
                                          control={<Radio />}
                                          label={value}
                                        />
                                      ))}
                                </RadioGroup>
                              </FormControl>
                            )}
                          </Grid>
                        );
                      })}
                  </Grid>
                  <Divider variant="middle" className={classes.divider} />
                  <div className={classes.buttons}>
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Cancel
                    </Button>

                    {this.state.isEsignatureRequired ?
                      <EsignatureConfirmation disableSubmit={this.state.disableSubmit} handleSubmit={(payload)=>{
                        this.setState({submitted:true});
                        this.handleSubmit(payload);
                      }}></EsignatureConfirmation>
                      :
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.disableSubmit}
                      onClick={() => {
                        this.setState({submitted:true});
                        this.handleSubmitWithOutSignature();
                      }}

                      
                    >
                      Submit
                    </Button>}
                  </div> 
                  
                </form>
             
          </Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const dynamicFormDetails = state.dynamicform.dynamicFormDetails;
  const isDynamicFormUpdated = state.dynamicform.isDynamicFormUpdated;
  return { dynamicFormDetails, isDynamicFormUpdated };
}

const mapDispatchToProps = (dispatch) => {
  return {
    findById: (id) => {
      dispatch(DynamicFormActions.getDynamicFormByIdRequest(id));
    },
    submit: (value) => {
      dispatch(DynamicFormActions.dynamicFormRequest(value));
    },
    clear: () => {dispatch(DynamicFormActions.clear());},
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DynamicForm));
